module.exports = __webpack_public_path__ + "media/images/official/special_exchange_04-0ff5bcc0df461e4be17f826ae58f968d.jpg";